
import axios, { AxiosResponse } from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import UmbracoApiService from "@/services/UmbracoApiService";
import WsdlService from "@/services/WsdlService";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import Swal from "sweetalert2";
import ServicioNotificacionBalanceModel from "@/models/ServicioNotificacionBalance/ServicioNotificacionBalanceModel";

@Component({})
export default class NotificationAportesForm extends Vue {
    @Prop() tipoFondo: FundTypeObj;
	@Prop() labelData: ServicioNotificacionBalanceModel;
    public checkProcesar: boolean = false;
    public correo: string = this.$store.state.user.correoElectronico1;
    public nombre: string = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;

    public check() {
        if (!this.checkProcesar) {
            Swal.fire({
                text: 'Debe Elegir "Si Acepto" para procesar su solicitud',
                icon: "error",
                showConfirmButton: true,
                confirmButtonText: "Ok",
            });
        }
    }
    public procesar() {
		
        this.$emit("nextStep");
    }
	returnHome() {
		this.$emit('returnHome');
    }
    public mounted() {}
}
